import type { UserResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { UsersGateway } from './users.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the Users index endpoints (`GET /users`, `DELETE /users/:id`, and the
 * `PATCH /users/:id/archive` the Licence detail's Users tab already uses). Sorting is a pure domain concern
 * applied in the selector, not here.
 */
export const httpUsersGateway: UsersGateway = {
  fetchUsers: () => api.get<UserResponse[]>('/users'),
  deleteUser: async (id: string) => {
    await api.delete(`/users/${id}`);
  },
  // The response is the user as saved; only its `archived_at` is read, so a
  // missing field (an older server) falls back to the intent; the Licence
  // detail gateway's rule.
  setArchived: async ({ id, archived }) => {
    const saved = await api.patch<Partial<UserResponse> | undefined>(`/users/${id}/archive`, {
      archived,
    });
    const archivedAt = saved?.archived_at;
    return {
      archivedAt:
        archivedAt !== undefined ? archivedAt : archived ? new Date().toISOString() : null,
    };
  },
};
